var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-no-menu',[_c('ion-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }